import { createHash } from 'crypto';

export function sha512(input: string) {
  const hash = createHash('sha512');
  hash.update(input);
  return hash.digest('hex');
}
